import { ArrowDownLeft, ArrowUpRight } from "lucide-react";

export default function TransactionRow({ txn }) {
  const { title, reference, date, method, amount, status, statusColor, type } = txn;
  const isCredit = type === "Credit";

  return (
    <div className="flex items-center justify-between gap-4 py-4 border-b border-gray-100 last:border-none">
      <div className="flex items-center gap-3 min-w-0">
        <div
          className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${
            isCredit ? "bg-green-50" : "bg-red-50"
          }`}
        >
          {isCredit ? (
            <ArrowDownLeft className="w-4 h-4 text-green-600" />
          ) : (
            <ArrowUpRight className="w-4 h-4 text-red-500" />
          )}
        </div>
        <div className="min-w-0">
          <p className="font-semibold text-gray-900 text-sm truncate">{title}</p>
          <p className="text-xs text-gray-500 truncate">
            {reference} · {date} · {method}
          </p>
        </div>
      </div>

      <div className="text-right shrink-0">
        <p className={`font-bold text-sm ${isCredit ? "text-green-600" : "text-gray-900"}`}>
          {isCredit ? "+" : "-"}₹{amount.toLocaleString("en-IN")}
        </p>
        <span className={`text-[11px] font-semibold px-2 py-0.5 rounded-full ${statusColor}`}>
          {status}
        </span>
      </div>
    </div>
  );
}